export default __webpack_public_path__ + "static/media/american-express-icon.6e120d85.svg";